<div class="licenses-page">
  <h1>Blocages actifs</h1>

  @if (managerError(); as error) {
    <p class="manager-error" role="alert">{{ error }}</p>
  }

  <div class="licenses-toolbar">
    <mat-form-field class="search-field" appearance="outline">
      <mat-label>Recherche</mat-label>
      <input matInput [value]="searchTerm()" (input)="updateSearchTerm($any($event.target).value)" placeholder="Nr INAMI ou Group ID" />
    </mat-form-field>

    <button mat-flat-button type="button" color="primary" (click)="openNihiiOverrideDialog()">
      Bloquer un INAMI
    </button>

    <button mat-flat-button type="button" color="primary" (click)="openGroupOverrideDialog()">
      Bloquer une DB
    </button>
  </div>

  <mat-tab-group>
    <mat-tab [label]="getNihiiTabLabel()">
      <table mat-table [dataSource]="nihiiOverridesDataSource" class="override-table" matSort #nihiiSort="matSort">
        <ng-container matColumnDef="nihii">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="nihii">Nr INAMI</th>
          <td mat-cell *matCellDef="let override">{{ override.nihii }}</td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="type">Type</th>
          <td mat-cell *matCellDef="let override">
            <ms-license-override-tag [overrideType]="override.type"></ms-license-override-tag>
          </td>
        </ng-container>

        <ng-container matColumnDef="reason">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="reason">Raison</th>
          <td mat-cell *matCellDef="let override">{{ override.reason }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let override">
            <button
              mat-icon-button
              type="button"
              color="warn"
              aria-label="Désactiver le blocage"
              [disabled]="!override.nihii"
              (click)="override.nihii && deleteNihiiOverride(override.nihii)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="nihiiColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: nihiiColumns"></tr>
      </table>
    </mat-tab>

    <mat-tab [label]="getGroupTabLabel()">
      <table mat-table [dataSource]="groupOverridesDataSource" class="override-table" matSort #groupSort="matSort">
        <ng-container matColumnDef="groupId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="groupId">Group ID</th>
          <td mat-cell *matCellDef="let override">{{ override.group_id }}</td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="type">Type</th>
          <td mat-cell *matCellDef="let override">
            <ms-license-override-tag [overrideType]="override.type"></ms-license-override-tag>
          </td>
        </ng-container>

        <ng-container matColumnDef="reason">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="reason">Raison</th>
          <td mat-cell *matCellDef="let override">{{ override.reason }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let override">
            <button
              mat-icon-button
              type="button"
              color="warn"
              aria-label="Désactiver le blocage"
              (click)="deleteGroupOverride(override.group_id!)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="groupColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: groupColumns"></tr>
      </table>
    </mat-tab>
  </mat-tab-group>
</div>
